import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
} from '@angular/core';
import { AbstractFormField } from '../../models/abstract-form-field/abstract-form-field.model';
import { FormErrorComponent } from '../form-error/form-error.component';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormErrorComponent],
  standalone: true,
  providers: [
    {
      provide: AbstractFormField,
      useExisting: forwardRef(() => FormFieldComponent),
    },
  ],
})
export class FormFieldComponent {
  readonly hint = input<string | undefined>(undefined);
  readonly label = model<string | undefined>();
}
